import React from 'react';
import Card from '@mui/material/Card';

export default function VCard(props) {
  return <Card variant="outlined" {...props} />;
}

